import React, { Fragment } from "react";
import RoundDashboard from "../../../../../d3Components/circlearc/RoundDashboard";

const CircleArcHolder = (props) => {
  const {
    typeName,
    getBacktest,
    port_info,
    display_orig_portfolio,
    clientBacktestData,
  } = props;

  let val_1, val_2, val_3;
  let heading1, heading2, heading3;
  const NewData = [];

  if (
    getBacktest &&
    display_orig_portfolio &&
    clientBacktestData.getPortfolioVami &&
    clientBacktestData.getPortfolioVami.length > 0 &&
    clientBacktestData.getBenchmarkVami &&
    clientBacktestData.getBenchmarkVami.length > 0
  ) {
    // based on client uploaded
    let data = clientBacktestData.getPortfolioVami;
    let original_data = data[data.length - 1]["vami"] * 1;
    val_3 = original_data;
    heading3 = "Orginal";
    // ------------
    val_1 =
      getBacktest.getPortfolioVami && getBacktest.getPortfolioVami.length > 0
        ? getBacktest.getPortfolioVami[getBacktest.getPortfolioVami.length - 1][
            "vami"
          ] * 1
        : 0;
    val_2 =
      getBacktest.getBenchmarkVami && getBacktest.getBenchmarkVami.length > 0
        ? getBacktest.getBenchmarkVami[getBacktest.getBenchmarkVami.length - 1][
            "vami"
          ] * 1
        : 0;
    heading1 = `IQCIO ${props.model_name ? "+" : ""}`;
    heading2 = "Benchmark *";

    NewData.push(
      { name: heading1, value: val_1 * 1, growth: val_1 * 1 },
      { name: heading2, value: val_2 * 1, growth: val_2 * 1 },
      { name: heading3, value: val_3 * 1, growth: val_3 * 1 }
    );
  } else if (getBacktest) {
    val_1 =
      getBacktest.getPortfolioVami[getBacktest.getPortfolioVami.length - 1][
        "vami"
      ] * 1;
    val_2 =
      getBacktest.getBenchmarkVami[getBacktest.getBenchmarkVami.length - 1][
        "vami"
      ] * 1;
    heading1 = "Portfolio";
    heading2 = typeName ? typeName : "Benchmark";

    NewData.push(
      { name: heading1, value: val_1 * 1, growth: val_1 * 1 },
      { name: heading2, value: val_2 * 1, growth: val_2 * 1 }
    );
  }

  return (
    <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
      {NewData.length > 0 ? (
        <Fragment>
          {NewData[0].value !== 0 && NewData[1].value !== 0 ? (
            <Fragment>
              <h4 className="text-uppercase bold">Total growth</h4>
              <div
                id="circle_arc_chart"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <svg viewBox="0 0 600 400" width={600} height={400}>
                  <RoundDashboard
                    width={600}
                    height={400}
                    NewData={NewData}
                    newBenchmarkName={props.newBenchmarkName}
                  />
                </svg>
              </div>
            </Fragment>
          ) : (
            <div style={{ textAlign: "center" }}>Bad data</div>
          )}
        </Fragment>
      ) : null}
    </div>
  );
};

export default CircleArcHolder;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/performance/portfolioGrowth/circleArc/circleArcHolder.jsx